<template>
  <div class="task-create">
    <div class="create-head">
      <p><span class="back" @click="$router.go(-1)">任务库</span><span class="line">/</span><span>我的任务</span></p>
      <p class="title">{{ isAdd ? '新建任务' : '修改任务' }}</p>
    </div>
    <div class="create-content">
      <Form :model="formData" ref="formData" :rules="rules" label-position="top" class="create-content-form">
        <FormItem label="任务名称" prop="name">
          <Input v-model.trim="formData.name" placeholder="请输入任务名称" />
        </FormItem>
        <FormItem label="难度" prop="difficulty">
          <Rate v-model="formData.difficulty" :count="5"></Rate>
        </FormItem>
        <FormItem label="环境" prop="env_id">
          <Select v-model="formData.env_id" placeholder="请选择环境" @on-change="getToolList($event), (formData.tools = undefined)">
            <Option v-for="(item, index) in envList" :key="index" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="工具要求" prop="tools">
          <Select v-model="formData.tools" :disabled="!formData.env_id" multiple placeholder="请选择在环境选择工具">
            <Option v-for="(item, index) in toolList" :key="index" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="文档">
          <!-- <FormItem label="文档" prop="docs"> -->
          <div v-if="$store.state.sysInfo.upload_type && $store.state.sysInfo.upload_type === 1">
            <Button ghost icon="ios-cloud-upload-outline">
              <input id="files" type="file" class="fileupload" @change="handleBeforeUploadOss" />
              <span class="ml6px">点击上传文件</span>
            </Button>
            <p class="mt-20px flex-no" v-if="fileList.length > 0">
              <span>{{ fileList[0].name }}</span>
              <span @click="removeFile()" class="del-btn">×</span>
            </p>
          </div>
          <Upload
            v-else
            ref="uploadImg"
            :on-success="handleSuccess"
            :default-file-list="fileList"
            :max-size="2048"
            :data="{ output: 'json' }"
            :format="['xls', 'xlsx', 'docx', 'doc', 'ppt', 'pptx', 'pdf']"
            action="/upload"
            v-model="formData.docs"
            :on-format-error="handleFormatError"
            :on-remove="removeFile"
            class="upload-text"
          >
            <Button ghost icon="ios-cloud-upload-outline"><span class="ml6px">点击上传文件</span></Button>
          </Upload>
        </FormItem>
        <FormItem label="任务介绍" prop="intro">
          <Input v-model.trim="formData.intro" type="textarea" :autosize="{ minRows: 4, maxRows: 7 }" placeholder="请输入任务介绍" />
        </FormItem>
        <FormItem label="任务步骤" prop="step">
          <!-- <TinyMce :content.sync="formData.step" /> -->
          <Editor :content.sync="formData.step" />
        </FormItem>
        <FormItem>
          <div class="flex">
            <Button ghost @click="$router.push({ name: 'task', query: $route.query })">取消</Button>
            <Button ghost style="margin-left: 12px" :loading="saveloading" @click="submit('formData', 1)">保存</Button>
            <Button type="primary" style="margin-left: 12px" v-if="formData.state !== 2 || !isAdd" :loading="subloading" @click="submit('formData', 2)"
              >发布</Button
            >
          </div>
        </FormItem>
      </Form>
    </div>
  </div>
</template>
<script>
import { Form, Button, Input, Rate, FormItem, Select, Option, Upload } from 'view-design'
// import TinyMce from '@/components/TinyMce/index.vue'
import Editor from '@/components/Editor/index.vue'
const OSS = require('ali-oss')
import { put } from '../../utils/ali-oss'
export default {
  components: {
    Form,
    Button,
    Input,
    Rate,
    FormItem,
    Option,
    Select,
    Upload,
    // TinyMce,
    Editor
  },
  data() {
    return {
      subloading: false,
      saveloading: false,
      formData: {
        name: '',
        docs: ''
      },
      isAdd: true,
      envList: [],
      fileList: [],
      toolList: [],
      rules: {
        name: [
          {
            required: true,
            message: '请输入任务名称',
            trigger: 'blur'
          }
        ],
        difficulty: [
          {
            required: true,
            message: '请选择难度',
            type: 'number',
            trigger: 'change'
          }
        ],
        env_id: [
          {
            required: true,
            message: '请选择环境',
            type: 'number',
            trigger: 'change'
          }
        ],
        tools: [
          {
            required: true,
            message: '请选择工具',
            trigger: 'change',
            type: 'array'
          }
        ],
        docs: [
          {
            required: true,
            message: '请上传文档',
            trigger: 'change'
          }
        ],
        intro: [
          {
            required: true,
            message: '请输入任务介绍',
            trigger: 'blur'
          }
        ],
        step: [
          {
            required: true,
            message: '请输入任务步骤',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    const item = JSON.parse(sessionStorage.getItem('item')) || {}
    if (item.id) {
      this.formData['id'] = item.id
      this.formData['name'] = item.name
      this.formData['env_id'] = item.envId
      this.formData['difficulty'] = item.difficulty
      this.formData['tools'] = item.tools
      this.formData['docs'] = item.docs
      this.formData['intro'] = item.intro
      this.formData['step'] = item.step.replaceAll('src="group1/default', 'src="/group1/default')
      this.formData['state'] = item.state
      const dlen = this.formData.docs.length
      const urllen = this.formData.docs.lastIndexOf('/')
      const name = this.formData.docs.substring(urllen + 1, dlen)
      this.fileList = [{ name: name, url: this.formData.docs }]
    }
    this.isAdd = this.formData.name ? false : true
    this.getEnvList()
    if (this.formData.tools) {
      this.getToolList(this.formData.env_id)
    }
  },
  methods: {
    handleFormatError() {
      this.$msg.error('只能上传WORD、PPT、PDF、EXCEL')
    },
    removeFile() {
      this.formData.docs = ''
      this.fileList = []
    },
    async getEnvList() {
      const params = {
        uriCode: 'API006'
      }
      const res = await this.$fetch(params)
      this.envList = res.list
    },
    async getToolList(e) {
      const params = {
        uriCode: 'API009',
        envId: e,
        limit: 100,
        page: 1
      }
      const res = await this.$fetch(params)
      this.toolList = res.list
    },
    submit(name, type) {
      // type  1保存 2发布
      this.$refs[name].validate(valid => {
        if (valid) {
          if (!this.formData.docs) {
            this.$msg.error('请上传文档！')
            return
          }
          this.handleOk(type)
        }
      })
    },
    async handleOk(type) {
      type === 1 ? (this.saveloading = true) : (this.subLoading = true)
      const params = {
        uriCode: 'API043',
        ...this.formData,
        state: type
      }
      try {
        await this.$fetch(params)
        this.$msg.success(`${type === 1 ? '保存成功' : '发布成功'}`)
        this.$router.push({ name: 'task', query: { my: 1 } })
      } finally {
        type === 1 ? (this.saveloading = false) : (this.subLoading = false)
      }
    },
    // 上传oss
    handleBeforeUploadOss(e) {
      let file = e.srcElement.files[0]
      if (file) {
        const type = file.name.substring(file.name.lastIndexOf('.'))
        const types = ['.xls', '.xlsx', '.docx', '.doc', '.ppt', '.pptx', '.pdf']
        const isImage = types.includes(type)
        if (!isImage) {
          this.$msg.error('只能上传WORD、PPT、PDF、EXCEL')
        } else {
          this.fileList = [{ name: file.name }]
          this.handleUpload(file)
        }
      } else {
        document.getElementById('files').value = null
        this.$msg.error('文件上传失败')
      }
    },
    // 上传验证
    handleBeforeUpload(file) {
      this.$refs.uploadImg.clearFiles()
      const type = file.name.substring(file.name.lastIndexOf('.'))
      const types = ['.xls', '.xlsx', '.docx', '.doc', '.ppt', '.pptx', '.pdf']
      const isImage = types.includes(type)
      if (!isImage) {
        this.$msg.error('只能上传WORD、PPT、PDF、EXCEL')
      } else {
        this.fileList = [{ name: file.name }]
        this.handleUpload(file)
      }
    },
    // 图片上传阿里云
    async handleUpload(file) {
      const params = {
        uriCode: 'API_PUB002'
      }
      const res = await this.$fetch(params)
      this.clientList = res
      // 自定义上传阿里云方法
      this.client = new OSS({
        region: 'oss-cn-beijing',
        accessKeyId: this.clientList.accessKeyId,
        accessKeySecret: this.clientList.accessKeySecret,
        stsToken: this.clientList.securityToken,
        bucket: 'svinsight-acs'
      })
      // 获取文件的后缀名
      const objs = file.name
      const index = objs.lastIndexOf('.')
      const filetype = objs.substring(index, objs.length)
      const fileName = objs.substring(0, index)
      // var obj = getFileNameUUID() + fileName
      // var obj = option.file.name
      var obj = fileName + filetype

      // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
      put(`actual_combat/${obj}`, file, this.client).then(res => {
        this.formData.docs = res.url
        if (res.url) {
          this.$msg.success('文件上传成功')
        } else {
          this.$msg.error('文件上传失败')
        }
        // 上传成功之后，转换真实的地址
      })
    },
    // 图片上传
    handleSuccess(res, file) {
      this.formData.docs = res.path
      this.fileList = [{ name: file.name, url: file.response.path }]
    }
  }
}
</script>
<style scoped lang="scss">
.task-create {
  .create {
    &-head {
      background-color: #fff;
      border-radius: 8px;
      padding: 16px 24px;
      margin-top: 10px;

      .back {
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;
      }

      .line {
        margin: 6px;
      }

      .title {
        height: 28px;
        font-size: 20px;
        font-weight: 500;
        color: rgba(28, 42, 52, 0.85);
        line-height: 28px;
        margin-top: 10px;
      }
    }

    &-content {
      border-radius: 2px;
      height: calc(100vh - 181px);
      background-color: #fff;
      margin-top: 10px;
      overflow-y: auto;

      &-form {
        max-width: 1000px;
        width: 100%;
        margin: 32px auto;
      }
    }
  }
}

.ivu-btn-ghost {
  color: rgba(0, 0, 0, 0.65) !important;
  border-color: #d7dde4 !important;
}

.ivu-btn-ghost:hover {
  color: #468fef !important;
  border-color: #468fef !important;
}

.ml6px {
  margin-left: 6px !important;
}

.flex-no {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  width: 100%;
}

.fileupload {
  height: 32px;
  opacity: 0;
  position: absolute;
  width: 136px;
  left: 0;
  top: 0;
}

.mt-20px {
  margin-top: 10px;
  line-height: 40px;
  border-radius: 6px;
  padding: 0 10px;
  transition: all 0.5 ease-in-out;

  .del-btn {
    color: #515a6e !important;
    font-size: 14px;
    margin-top: -8px;
    display: none;
    cursor: pointer;
  }

  .del-btn:hover {
    color: #007aff !important;
  }
}

.mt-20px:hover {
  background-color: #f0f2f3;
  color: #007aff;

  .del-btn {
    display: block;
  }
}

.ml-10px {
  margin-left: 10px;
}

.flex {
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
}
</style>
